<template>
  <div class="help-center fd-c f--c">
    <h1>{{ $t('Home.helpCenter.SearchHead.HELPCENTER') }}</h1>
    <el-input style="width:730px;" prefix-icon="el-icon-search" v-model="input" @change="handleSearch">
    </el-input>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: ''
    }
  },
  created() {
    if (this.$route.query.keyword) {
      this.input = this.$route.query.keyword
    }
  },
  methods: {
    handleSearch() {
      this.$emit('handleSearch', this.input)
      this.$router.push({
        path: '/help-center/search-center',
        query: {
          keyword: this.input
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.help-center {
  height: 200px;
  background: #f6f5f6;
  h1 {
    font-size: 30px;
    font-weight: 600;
    text-align: center;
    color: #121e26;
    padding: 30px 0 20px;
    line-height: 50px;
  }
}
/deep/.el-input__inner {
  height: 50px;
  padding-left: 40px;
}
/deep/.el-input__prefix {
  left: 8px;
  top: 3px;
  font-size: 20px;
}
</style>

